import React from "react";
import MenuItem from "./MenuItem";
const MenuItemContainer = ({ displayItems }) => {
    if (displayItems) {
        return (
            <div className='m-2 flex max-h-[400px] flex-wrap  gap-2 overflow-y-auto '>
                {displayItems.map((item, index) => {
                    return (
                        <MenuItem id={item._id} key={index} name={item.name} price={item.price} />
                    );
                })}
            </div>
        );
    } else {
        return (
            <div className='m-2 flex max-h-[400px] flex-wrap  gap-2 overflow-y-auto '>
                <div className='text-2xl text-center text-white'>No items found</div>
            </div>
        );
    }
};

export default MenuItemContainer;
